<template>
  <div v-if="screen.isDesktop" class="field">
    <label class="text-helped"
      ><img
        class="icon-rating-type"
        :src="`/assets/img/icons/${iconName}`"
        onerror="this.src='/assets/img/icons/none.svg'"
        alt="SOCO"
      />{{ titleAfterFilter }}</label
    >

    <div class="fieldarea">
      <div class="rate ratebig">
        <input name="value_of_money" type="hidden" value="" />
        <ul>
          <li
            v-for="(item, key) in ratingInput"
            :key="`${name}_${key}`"
            class="icon_star"
            :class="{ active: item.isActive }"
            @click.prevent="toggleRating(key)"
          >
            <input :id="`${name}_${key}`" :name="item.name" type="radio" value="1" />
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div v-else class="field">
    <!-- <label class="text-helped"><img class="icon-rating-type" :src="`/assets/img/icons/${iconName}`" onerror="this.src='/assets/img/icons/none.svg'" alt="SOCO"/>{{ titleAfterFilter }}</label> -->
    <label class="text-helped">{{ titleAfterFilter }}</label>

    <div class="fieldarea">
      <div class="rate ratebig">
        <input name="value_of_money" type="hidden" value="" />
        <ul>
          <li
            v-for="(item, key) in ratingInput"
            :key="`${name}_${key}`"
            class="icon_star"
            :class="{ active: item.isActive }"
            @click.prevent="toggleRating(key)"
          >
            <input :id="`${name}_${key}`" :name="item.name" type="radio" value="1" />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String, default: '' },
    name: { type: String, default: '' },
    ratingTypes: { type: Object, default: () => {} },
  },
  data() {
    return {
      isChoose: false,
      ratingInput: [
        {
          name: 'ratingInput_1',
          isActive: false,
        },
        {
          name: 'ratingInput_2',
          isActive: false,
        },
        {
          name: 'ratingInput_3',
          isActive: false,
        },
        {
          name: 'ratingInput_4',
          isActive: false,
        },
        {
          name: 'ratingInput_5',
          isActive: false,
        },
      ],
    };
  },
  computed: {
    titleAfterFilter() {
      const nameToLowerCase = this.title.toLowerCase();
      const removeWordIsStar = nameToLowerCase.replace(/is_star_|star_/gi, '');
      const removeDash = removeWordIsStar.replace(/[_]/gi, ' ');

      if (removeDash === 'eficiency') {
        return 'efficiency';
      }

      return removeDash;
    },
    iconName() {
      const name = this.titleAfterFilter.toLowerCase().replace(/\s/g, '-');
      return `${name}.svg`;
    },
    screen() {
      return this.$store.state.screen;
    },
  },
  created() {
    this.provideValueRatingIfExists();
  },
  methods: {
    toggleRating(key) {
      const totalRating = parseInt(key) + 1;

      for (let i = 0; i < 5; i++) {
        this.ratingInput[i].isActive = i < totalRating;
      }

      this.$emit('getRating', {
        value: totalRating,
        name: this.name,
      });
    },
    provideValueRatingIfExists() {
      if (this.ratingTypes && this.ratingTypes[this.title] && this.ratingTypes[this.title].value) {
        for (let i = 0; i < this.ratingTypes[this.title].value; i++) {
          this.ratingInput[i].isActive = true;
        }
      }
    },
  },
};
</script>
